import { Component, inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { CreditWindowPaymentService } from '../../../data-access/services/credit-window-payment.service';
import { SupportMessengerService } from '@client-monorepo/common/utilities';
import { RouterOutlet } from '@angular/router';
import { CreditServiceTypeService } from '../../credit/data-access/services/credit-service-type.service';

@Component({
  selector: 'app-credit-page',
  templateUrl: './credit-page.component.html',
  styleUrls: ['./credit-page.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [RouterOutlet],
})
export class CreditPageComponent implements OnInit, OnDestroy {
  creditWindowPaymentService = inject(CreditWindowPaymentService);
  supportMessengerService = inject(SupportMessengerService);
  serviceTypeService = inject(CreditServiceTypeService);

  ngOnInit(): void {
    this.serviceTypeService.setServiceType('credit');
    this.creditWindowPaymentService.attachCreditPayment();
    this.supportMessengerService.show();
  }

  ngOnDestroy(): void {
    this.supportMessengerService.hide();
  }
}
